/* Back to top */

export function back_to_top() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.footer-back-to-top' ).length <= 0 ) {
				return;
			}

			$( '.footer-back-to-top button' ).on( 'click', ( ev ) => {
				ev.preventDefault();

				$( 'html, body' ).animate( {
					scrollTop: 0
				} );
			} );
		}

		init();

	} )( window.jQuery );

}